module.exports = __webpack_public_path__ + "img/dl_dd@2x.1485809f.png";